import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  FormControlLabel,
  FormGroup,
  CircularProgress,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import TabPanel from "../../components/TabPanel";
import BillItems from "./bill/items";
import BillRelationship from "./bill/relationship";
import BillCommunication from "./bill/communication";
import BillRelatedRecords from "./bill/relatedRecords";
import BillSystemInformation from "./bill/systemInformation";
import BillCustom from "./bill/custom";
import PhilippinesInvoicing from "./bill/philippinesInvoicing";
import {
  getTransactionBillPaymentPayeeAddress,
  getTransactionEft,
  getTransactionJPMorganDetails,
  getTransactionSalesOrderTaxAndReporting,
  getTransactionVendorBilling,
} from "../../api/transaction-type";
import BillAvaTax from "./bill/avaTax";
import ApprovalHistory from "./bill/ApprovalHistory";
import { getTransactionCheckDetails } from "../../api/vendor-bill";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import CheckItems from "./check/checkItems";
import CheckRelationship from "./check/relationships";
import CheckCommunication from "./check/communication";
import CheckCreditSystemInformation from "./check/system-information";
import CheckCustom from "./check/custom";
import CheckEft from "./check/eft.jsx";
import CheckRelatedRecords from "./check/related-records.jsx";
export default function TransactionTypeCheck() {
  const params = useParams();
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);

  /*----------------End Tabs-----------------*/
  const [rowData, setRowData] = useState([]);
  const [eftData, seteftData] = useState([]);
  const [tax_R_Data, setTax_R_Data] = useState([]);
  const [Billing_Data, setBilling_Data] = useState([]);
  const [jpMorganData, setJpMorganData] = useState([]);
  const [payeeAddData, setPayeeAddData] = useState([]);
   const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (user.token) {
      getTransactionDocDetailTableData();
    }
  }, []);
  async function getTransactionDocDetailTableData() {
    setLoading(true);
    try {
      const { data } = await getTransactionCheckDetails(user.token, {
        tranid: params.docNo,
        limit: 1,
        offset: 0,
        // type: pageDetail.path,
      });
      setRowData(data.data.details[0]);
      setLoading(false);
      return {
        rows: data.data.details,
        total: data.data.Detailstotal,
        error: false,
      };
    } catch (error) {
      setLoading(false);
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  async function getJPMorganEftData() {
    try {
      const { data } = await getTransactionJPMorganDetails(user.token, {
        id: params.docNo,
      });
      setJpMorganData(data.data.data);
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
    }
  }
  useEffect(() => {
    if (user.token && tabIndex === 7) {
      getTransactionEftData();
    }
    if (user.token && tabIndex === 8) {
      getJPMorganEftData();
    }
    if (user.token && tabIndex === 1) {
     getTransactionDocBillPaymentPayeeAddData();
    }
  }, [tabIndex]);

  async function getTransactionEftData() {
    try {
      const { data } = await getTransactionEft(user.token, {
        id: params.docNo,
      });
      seteftData(data.data.data);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
    }
  }

  // async function getTransactionbillingData() {
  //   try {
  //     const { data } = await getTransactionVendorBilling(user.token, {
  //       id: params.docNo,
  //     });
  //     setBilling_Data(data.data.data);
  //     return { rows: data.data.data, total: data.data.total, error: false };
  //   } catch (error) {
  //     console.log(error);
  //     snackbar.showError("Error In Loading Data.");
  //     return { error: true };
  //   } finally {
  //   }
  // }
  
  async function getTransactionDocBillPaymentPayeeAddData() {
    try {
      const { data } = await getTransactionBillPaymentPayeeAddress(user.token, {
        id: params.docNo,
      });
      setBilling_Data(data.data.data[0]);
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  // async function getTransactionVendorBillTaxAndReportingData() {
  //   try {
  //     const { data } = await getTransactionSalesOrderTaxAndReporting(
  //       user.token,
  //       {
  //         id: params.docNo,
  //       }
  //     );
  //     setTax_R_Data(data.data.data);
  //     return { rows: data.data.data, total: data.data.total, error: false };
  //   } catch (error) {
  //     console.log(error);
  //     snackbar.showError("Error In Loading Data.");
  //     return { error: true };
  //   } finally {
  //   }
  // }
  return loading ? (
     <>
       <Typography component="h4" fontWeight={500} className="pageTitle">
       Check
       </Typography>
      
       <Box className="viewBox">
         <Box
           className="headerItems"
           display="flex"
           alignItems="center"
           justifyContent="space-between"
           pb={2}
         >
           <Typography component="h5" fontWeight={500} className="pageHeading1">
             Primary Information
           </Typography>
           <Link to={"/transaction-type/" + params.slug}>
             <Button size="small" variant="contained" className="backBtn">
               Go Back
             </Button>
           </Link>
         </Box>
         <Box className="viewDetilsBox">
           <Grid container className="mb-2">
             <Grid item xs={12}>
               <div
                 style={{
                   width: "100%",
                   display: "flex",
                   justifyContent: "center",
                   alignItems: "center",
                 }}
               >
                 <CircularProgress></CircularProgress>
               </div>
             </Grid>
           </Grid>
         </Box>
       </Box>
       <Box className="viewBox">
         <Box
           className="headerItems"
           display="flex"
           alignItems="center"
           justifyContent="space-between"
           pb={2}
         >
           <Typography component="h5" fontWeight={500} className="pageHeading1">
             Classification
           </Typography>
         </Box>
         <Box className="viewDetilsBox">
           <Grid container className="mb-2">
             <Grid item xs={12}>
               <div
                 style={{
                   width: "100%",
                   display: "flex",
                   justifyContent: "center",
                   alignItems: "center",
                 }}
               >
                 <CircularProgress></CircularProgress>
               </div>
             </Grid>
           </Grid>
         </Box>
       </Box>
       <Box className="viewBox">
         <Box
           className="headerItems"
           display="flex"
           alignItems="center"
           justifyContent="space-between"
           pb={2}
         >
          
         </Box>
         <Box className="viewDetilsBox">
           <Grid container className="mb-2">
             <Grid item xs={12}>
               <div
                 style={{
                   width: "100%",
                   display: "flex",
                   justifyContent: "center",
                   alignItems: "center",
                 }}
               >
                 <CircularProgress></CircularProgress>
               </div>
             </Grid>
           </Grid>
         </Box>
       </Box>
     </>
   ) : (
    <>
      <Typography component="h4" fontWeight={500} className="pageTitle">
        Check
      </Typography>
      <Typography component="h5" sx={{ mb: 2 }}>
        {/* {rowData.map((d, i) => ( */}
          <span className="para-no">
            <strong>{rowData.check_no}</strong> {rowData.payee}
          </span>
         {/* ))} */}
       
        </Typography>
      {/*Primary Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData?.map((el, i) => ( */}
            <Grid container className="mb-2" >
              <Grid item xs={12} sm={12} md={12}>
                <Grid container className="mb-2">
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">TRANSACTION NUMBER</p>
                    <p className="tFormName">{rowData?.transaction_number}</p>
                  </Grid>
                  {/* <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <FormGroup>
                      <FormControlLabel
                        control={<checkbox  disabled/>}
                        label="PAYMENT HOLD"
                      />
                    </FormGroup>
                  </Grid> */}
                            <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">AMOUNT</p>
                    <p className="tFormName">{rowData?.amount}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">POSTING PERIOD</p>
                    <p className="tFormName">{rowData?.posting_period}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">PAYEE</p>
                    <p className="tFormName">{rowData?.payee}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">CURRENCY</p>
                    <p className="tFormName">{rowData?.currency}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              rowData?.to_be_printed === "" ||
                              rowData?.to_be_printed === "F"
                                ? false
                                : true
                            }
                          />
                        }
                        label="TO BE PRINTED"
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">SUBSIDIARY</p>
                    <p className="tFormName">{rowData?.subsidiary}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">EXCHANGE RATE</p>
                    <p className="tFormName">{rowData?.exchangerate}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">CHECK #</p>
                    <p className="tFormName">{rowData?.check_no}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">ACCOUNT</p>
                    <p className="tFormName">{rowData?.account}</p>
                  </Grid>
                  
                  {/* <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">Tax</p>
                    <p className="tFormName">{rowData?.tax}</p>
                  </Grid> */}

             
        
                 

                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">DATE</p>
                    <p className="tFormName">{rowData?.date}</p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <p className="tFormlabel">MEMO</p>
                    <p className="tFormName">{rowData?.memo}</p>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} className="m-b-10">
                    <p className="tFormlabel">BALANCE</p>
                    <p className="tFormName">{rowData?.balance}</p>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          {/* ))} */}
        </Box>
      </Box>
      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData?.map((el, i) => ( */}
            <Grid container className="mb-2" >
          
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">Department</p>
                <p className="tFormName">{rowData?.department}</p>
              </Grid>

              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">SERVICE LINE</p>
                <p className="tFormName">{rowData?.service_line}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              rowData?.to_be_printed === "" ||
                              rowData?.to_be_printed === "F"
                                ? false
                                : true
                            }
                          />
                        }
                        label="ACTUAL RELATED"
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">MIDDLE MAN VAT ID</p>
                <p className="tFormName">{rowData?.middile_vat_man_id}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              rowData?.to_be_printed === "" ||
                              rowData?.to_be_printed === "F"
                                ? false
                                : true
                            }
                          />
                        }
                        label="SEND IMPORT ADDRESS TO AVATAX"
                      />
                    </FormGroup>
                  </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel">ORIGINAL INVOICE DATE</p>
                <p className="tFormName">{rowData?.original_invoice_date}</p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                <p className="tFormlabel"> AVALARA CREATED FROM</p>
                <p className="tFormName">{rowData?.avalara_created_from}</p>
              </Grid>
            </Grid>
          {/* ))} */}
        </Box>
      </Box>

      <Box>
        <Box
          className="viewBox "
          sx={{
            maxWidth: { xs: "100%", sm: "100%", md: "100%" },
            bgcolor: "#fff",
          }}
        >
          <Tabs
            value={tabIndex}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg"
          >
            <Tab label="Expenses and Items" />
            <Tab label="Payee Address" />
            <Tab label="Related Records" />
            <Tab label="Relationships" />
            <Tab label="Communication" />
            <Tab label="System Information" />
            <Tab label="Custom" />
            <Tab label="EFT" />
            <Tab label="JP Morgan" />
          </Tabs>
          {/*------------Items------------*/}
          <TabPanel value={tabIndex} index={0}>
            <CheckItems />
          </TabPanel>
          {/*------------Payee Address------------*/}
          <TabPanel value={tabIndex} index={1}>
            {/* {Billing_Data?.map((el, i) => ( */}
              <Box className="viewDetilsBox">
                <Grid container>
                  <Grid item xs={12} sm={12}>
                    <p className="tFormlabel">PAY TO</p>
                    <p className="tFormName">{Billing_Data.vendor}</p>
                  </Grid>
                </Grid>
              </Box>
            {/* ))} */}
          </TabPanel>
            {/* RelatedRecords */}
            <TabPanel value={tabIndex} index={2}>
            {tabIndex === 2 && (
              <CheckRelatedRecords tabIndexP={tabIndex} />
            )}
          </TabPanel>
          {/* RelatedRecords */}
          {/*------------Relationships------------*/}
          <TabPanel value={tabIndex} index={3}>
            {tabIndex === 3 && <CheckRelationship />}
          </TabPanel>
          {/*------------Communication------------*/}
          <TabPanel value={tabIndex} index={4}>
            {tabIndex === 4 && <CheckCommunication />}
          </TabPanel>
          {/*-------------System Information-----------*/}
          <TabPanel value={tabIndex} index={5}>
            {tabIndex === 5 && <CheckCreditSystemInformation />}
          </TabPanel>
          {/*-------------CUSTOM-----------*/}
          <TabPanel value={tabIndex} index={6}>
            {tabIndex === 6 && <CheckCustom />}
          </TabPanel>
          {/*------------EFT-----------*/}
          <TabPanel value={tabIndex} index={7}>
            {tabIndex ===7 && <CheckEft/>}
          </TabPanel>

          {/*-------------jp morgan-----------*/}
          <TabPanel value={tabIndex} index={8}>
          <Box className="viewDetilsBox">
            {/* {tax_R_Data?.map((el, index) => (
              <Box className="viewDetilsBox" key={index}> */}
                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <p className="tFormlabel">J.P.MORGAN REFERENCE ID</p>
                    <p className="tFormName">{rowData.reference_id}</p>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <p className="tFormlabel">J.P.MORGAN STATUS</p>
                    <p className="tFormName">{rowData.status}</p>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <p className="tFormlabel">J.P.MORGAN MESSAGE</p>
                    <p className="tFormName">{rowData.message}</p>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <p className="tFormlabel">J.P.MORGAN UPDATED DATE</p>
                    <p className="tFormName">{rowData.updated_date}</p>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <p className="tFormlabel">J.P.MORGAN PAYER</p>
                    <p className="tFormName">{rowData.payer}</p>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <p className="tFormlabel">J.P.MORGAN TRANSACTION ID</p>
                    <p className="tFormName">{rowData.transaction_id}</p>
                  </Grid>
                </Grid>
              </Box>
          </TabPanel>
        </Box>
      </Box>
    </>
  );
}
